import React, { useEffect } from "react";
import "./footer.css";
import { useDispatch, useSelector } from "react-redux";
import { listStoreCategories } from "../Redux/Actions/CategoryActions";
import { getPublicStoreSettings } from "../Redux/Actions/storeSettingActions";

const formatPhone = (number = "") => {
  const clean = String(number).replace(/\D/g, "");

  if (clean.startsWith("57") && clean.length === 12) {
    const local = clean.slice(2);
    return `${local.slice(0, 3)} ${local.slice(3, 6)} ${local.slice(6)}`;
  }

  if (clean.length === 10) {
    return `${clean.slice(0, 3)} ${clean.slice(3, 6)} ${clean.slice(6)}`;
  }

  return clean;
};

const Footer = () => {
  const dispatch = useDispatch();

  const categoryStoreList = useSelector((state) => state.categoryStoreList);
  const rawCategories = categoryStoreList?.categories;

  const { settings = {} } = useSelector(
    (state) => state.publicStoreSettings || {}
  );

  const whatsappNumbers = Array.isArray(settings.whatsappNumbers)
    ? settings.whatsappNumbers
    : settings.whatsappNumber
      ? [settings.whatsappNumber]
      : [];

  const categories = Array.isArray(rawCategories)
    ? rawCategories
    : Array.isArray(rawCategories?.categories)
      ? rawCategories.categories
      : [];

  useEffect(() => {
    if (!categories.length) {
      dispatch(listStoreCategories());
    }

    dispatch(getPublicStoreSettings());
  }, [dispatch, categories.length]);

  return (
    <div className="footer">
      <div className="sb_footer section_padding">
        <div className="sb_footer-links">
          <div className="sb_footer-links_div">
            <h4>AltaModa</h4>
            <a href="/quienes-somos">
              <p>Quienes Somos</p>
            </a>
            <a href="/mision-vision">
              <p>Misión y Visión</p>
            </a>
          </div>

          <div className="sb_footer-links_div">
            <h4>Nuestras Categorías</h4>
            {categories.length > 0 ? (
              categories.slice(0, 7).map((cat) => (
                <a key={cat._id} href={`/categorias/${cat.slug}`}>
                  <p>
                    {cat.name.charAt(0).toUpperCase() +
                      cat.name.slice(1).toLowerCase()}
                  </p>
                </a>
              ))
            ) : (
              <p>Cargando...</p>
            )}
          </div>

          <div className="sb_footer-links_div">
            <h4>FAQ y Políticas</h4>
            <a href="/terminos-del-servicio">
              <p>Términos del Servicio</p>
            </a>
            <a href="/politica-de-privacidad">
              <p>Política de Privacidad</p>
            </a>
            <a href="/politica-de-envio">
              <p>Política de Envío</p>
            </a>
            <a href="/politica-de-devolucion">
              <p>Política de Devolución</p>
            </a>
          </div>

          <div className="sb_footer-links_div">
            <h4>Contáctanos</h4>

            <a
              href="https://maps.app.goo.gl/QkbD1jFyqqrzja2u8"
              target="_blank"
              rel="noopener noreferrer"
            >
              <p>Calle 17 #8 - 20</p>
            </a>

            <a
              href="https://maps.app.goo.gl/vupJrD6ZpKDYLwjv5"
              target="_blank"
              rel="noopener noreferrer"
            >
              <p>Cra 8 #16b - 76</p>
            </a>

            <a
              href="https://maps.app.goo.gl/t5iEjjy1bJM6MrAU7"
              target="_blank"
              rel="noopener noreferrer"
            >
              <p>Cra 9 #16b - 63</p>
            </a>

            {whatsappNumbers.length > 0 ? (
              whatsappNumbers.map((number, index) => (
                <a
                  key={`${number}-${index}`}
                  href={`https://wa.me/${number}?text=${encodeURIComponent(
                    "Hola, estoy interesad@ en uno de sus productos"
                  )}`}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <p>{formatPhone(number)}</p>
                </a>
              ))
            ) : (
              <p>WhatsApp no configurado</p>
            )}
          </div>

          <div className="sb_footer-links_div">
            <h4>Síguenos</h4>
            <div className="socialmedia">
              <a
                href="https://www.instagram.com/altamoda17.valledupar/"
                target="_blank"
                rel="noopener noreferrer"
              >
                <i className="fab fa-instagram"></i>
              </a>
            </div>
          </div>
        </div>

        <hr />

        <div className="sb_footer-below">
          <div className="sb_footer-copyright">
            <p>
              © {new Date().getFullYear()} AltaModa. Todos los derechos
              reservados.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Footer;